// extracted by mini-css-extract-plugin
module.exports = {"icon_modal":"loading_icon_modal__3BNx0"};